import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Optional, Copy, Box, Column, Row } from '@honda-canada/design-system-react';
import themeStyles from './styles/NoticeSection.styles';
import NoticeWithVideo from './NoticeWithVideo';
import { campaignPropTypes } from '../../utils/interface';
import generateDataTestId from '../../utils/generateDataTestId';
import useConfiguration from '../../hooks/useConfiguration';

const Container = themeStyles.apply(Box, 'Container');
const NoticeSectionRow = themeStyles.apply(Row, 'NoticeSectionRow');
const HeadingContainer = themeStyles.apply(Box, 'HeadingContainer');
const NoticeLabel = themeStyles.apply(Copy, 'NoticeLabel');
const NoticeAmount = themeStyles.apply(Copy, 'NoticeAmount');

const NoticeSection = ({ campaignSection }) => {
  const { counterColour } = useConfiguration();
  const descendedSortedCampaigns = useMemo(
    () =>
      campaignSection?.campaigns.sort((a, b) => {
        const dateA = new Date(a.servicedOn);
        const dateB = new Date(b.servicedOn);
        return dateB - dateA;
      }),
    [campaignSection?.campaigns],
  );

  if (!campaignSection || !campaignSection?.campaigns) {
    return null;
  }

  const campaignLength = campaignSection?.campaigns?.length;
  const sectionTitle = campaignSection?.title;

  return (
    <Container mt={7} data-testid={generateDataTestId(sectionTitle, 'section')}>
      <Column>
        <HeadingContainer data-testid={generateDataTestId(sectionTitle, 'heading')}>
          <NoticeLabel data-testid={generateDataTestId(sectionTitle, 'label')} zeroItems={!campaignLength}>
            {campaignSection?.title}
          </NoticeLabel>
          &nbsp;
          <NoticeAmount
            data-testid={generateDataTestId(sectionTitle, 'counter')}
            zeroItems={!campaignLength}
            counterColour={counterColour}
          >
            {campaignSection?.amountIdentifier}
          </NoticeAmount>
        </HeadingContainer>
      </Column>

      <Optional when={campaignSection.campaigns.length}>
        <NoticeSectionRow data-testid="cy-card-section">
          {descendedSortedCampaigns?.map(campaign => (
            <NoticeWithVideo campaign={campaign} key={campaign.id} />
          ))}
        </NoticeSectionRow>
      </Optional>
    </Container>
  );
};

NoticeSection.propTypes = {
  campaignSection: PropTypes.shape({
    campaigns: PropTypes.arrayOf(campaignPropTypes),
    title: PropTypes.string,
    amountIdentifier: PropTypes.string,
  }),
};

export default NoticeSection;
